import { UpdateResolver } from '@urql/exchange-graphcache';

type ApplyPromptLinkingResult = {
  applyPromptLinking?: {
    success: boolean;
    message?: string | null;
  } | null;
};

type ApplyPromptLinkingVariables = {
  input: {
    orderEntryIds: string[];
    prompt: string;
    usePromptForLinking: boolean;
  };
};

export const applyPromptLinkingResolver: UpdateResolver<
  ApplyPromptLinkingResult,
  ApplyPromptLinkingVariables
> = (result, args, cache) => {
  const ids = args.input.orderEntryIds || [];

  // Invalidate each affected OrderEntry and its parent Order to force refetch
  ids.forEach((id) => {
    const entryKey = cache.keyOfEntity({ __typename: 'OrderEntry', id });
    if (entryKey) {
      // Try to read the orderId off the entity before invalidating
      const orderId = cache.resolve(entryKey, 'orderId') as string | null;

      // Invalidate the OrderEntry node (forces active queries to re-read)
      cache.invalidate(entryKey);

      if (orderId) {
        // Invalidate the order and its orderEntries field
        cache.invalidate({ __typename: 'Order', id: orderId });
        cache.invalidate({ __typename: 'Order', id: orderId }, 'orderEntries');
      }
    }
  });
};
